export const EMPTY_BOOKING = {
  guest_name: "", guest_surname: "", property_id: "", checkin: "", checkout: "",
  checkin_time: "", checkout_time: "", flight: "",
  adults: 2, children: 0, origine: "Diretto", total_amount: 0, acconto: 0, saldo: 0,
  age_adults: 0, age_child_5_13: 0, age_child_2_4: 0, age_infant: 0,
  payment_method: "conto_corrente", acconto_method: "conto_corrente", saldo_method: "conto_corrente", commission: 0, no_commission: false, notes: "",
  acconto_due_date: "", saldo_due_date: "",
  installments_enabled: false, installments: [],
  passport_number: "", nationality: "", birth_date: "", sex: "", expiry_date: "",
  country: "", passport_image: "", extra_guests: [],
  segments: [],
  guest_email: "", guest_phone: "",
  status: "confermata", option_expiry_days: 7, option_expiry_date: "", payment_status: "none", cancellation: null,
};

export const EMPTY_GUEST = {
  name: "", surname: "", passport_number: "", nationality: "", birth_date: "",
  sex: "", expiry_date: "", country: "", passport_image: "",
};

export const isoAdd = (base, days) => {
  const d = base ? new Date(base) : new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
};

export const splitName = (fullName) => {
  const full = (fullName || "").trim();
  const parts = full.split(" ");
  return {
    name: parts.slice(0, -1).join(" ") || full,
    surname: parts.length > 1 ? parts[parts.length - 1] : "",
  };
};

// Preferisce i campi separati surname/given_names dell'OCR; fallback su full_name.
export const resolveName = (data) => {
  const surname = (data.surname || "").trim();
  const given = (data.given_names || "").trim();
  if (surname || given) return { name: given, surname };
  return splitName(data.full_name);
};

export const scanToGuest = (data, dataUrl) => {
  const { name, surname } = resolveName(data);
  return {
    name, surname,
    passport_number: data.passport_number || "", nationality: data.nationality || "",
    birth_date: data.birth_date || "", sex: data.sex || "", expiry_date: data.expiry_date || "",
    country: data.country || "", passport_image: dataUrl || "",
  };
};


// Orari speedboat: configurabili in Trasferimenti (lib/speedboat.js); venerdì diverso
export const isFridayIso = (iso) => {
  if (!iso) return false;
  const d = new Date(iso + "T00:00:00");
  return !isNaN(d) && d.getDay() === 5;
};

// Mantiene il valore corrente anche se fuori lista (prenotazioni vecchie es. 14:00)
export const sbOptions = (opts, current) =>
  current && !opts.includes(current) ? [...opts, current] : opts;
